import { __assign, __extends } from "tslib";
import { ClientDefaultValues as __ClientDefaultValues } from "./runtimeConfig";
import { resolveEndpointsConfig, resolveRegionConfig } from "@aws-sdk/config-resolver";
import { getContentLengthPlugin } from "@aws-sdk/middleware-content-length";
import { getHostHeaderPlugin, resolveHostHeaderConfig } from "@aws-sdk/middleware-host-header";
import { getLoggerPlugin } from "@aws-sdk/middleware-logger";
import { getRetryPlugin, resolveRetryConfig } from "@aws-sdk/middleware-retry";
import { resolveAwsAuthConfig } from "@aws-sdk/middleware-signing";
import { getUserAgentPlugin, resolveUserAgentConfig } from "@aws-sdk/middleware-user-agent";
import { Client as __Client } from "@aws-sdk/smithy-client";
/**
 * <fullname>Amazon Cognito Federated Identities</fullname>
 *          <p>Amazon Cognito Federated Identities is a web service that delivers scoped temporary
 *          credentials to mobile devices and other untrusted environments. It uniquely identifies a
 *          device and supplies the user with a consistent identity over the lifetime of an
 *          application.</p>
 *          <p>Using Amazon Cognito Federated Identities, you can enable authentication with one or
 *          more third-party identity providers (Facebook, Google, or Login with Amazon) or an Amazon
 *          Cognito user pool, and you can also choose to support unauthenticated access from your app.
 *          Cognito delivers a unique identifier for each user and acts as an OpenID token provider
 *          trusted by AWS Security Token Service (STS) to access temporary, limited-privilege AWS
 *          credentials.</p>
 *          <p>For a description of the authentication flow from the Amazon Cognito Developer Guide
 *          see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/authentication-flow.html">Authentication Flow</a>.</p>
 *          <p>For more information see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/cognito-identity.html">Amazon Cognito Federated Identities</a>.</p>
 */

var CognitoIdentityClient =
/** @class */
function (_super) {
  __extends(CognitoIdentityClient, _super);

  function CognitoIdentityClient(configuration) {
    var _this = this;

    var _config_0 = __assign(__assign({}, __ClientDefaultValues), configuration);

    var _config_1 = resolveRegionConfig(_config_0);

    var _config_2 = resolveEndpointsConfig(_config_1);

    var _config_3 = resolveAwsAuthConfig(_config_2);

    var _config_4 = resolveRetryConfig(_config_3);

    var _config_5 = resolveUserAgentConfig(_config_4);

    var _config_6 = resolveHostHeaderConfig(_config_5);

    _this = _super.call(this, _config_6) || this;
    _this.config = _config_6;

    _this.middlewareStack.use(getRetryPlugin(_this.config));

    _this.middlewareStack.use(getUserAgentPlugin(_this.config));

    _this.middlewareStack.use(getContentLengthPlugin(_this.config));

    _this.middlewareStack.use(getHostHeaderPlugin(_this.config));

    _this.middlewareStack.use(getLoggerPlugin(_this.config));

    return _this;
  }

  CognitoIdentityClient.prototype.destroy = function () {
    _super.prototype.destroy.call(this);
  };

  return CognitoIdentityClient;
}(__Client);

export { CognitoIdentityClient };